import { Force, Measure, newtons } from 'safe-units';

export const poundForce: Force = Measure.of(4.4482216153, newtons);
